import * as React from 'react'
import { sortBy } from 'lodash'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService } from '../../../../core/services'
import * as Hooks from '../../../../utils/hooks'
import { Panel } from '../../../atoms'
import { EditTable } from '../../../organisms'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'

interface IProps {
  posts: {
    posts: IJsonResponse
  }
  user: IJsonResponse
}

const COLUMNS = [
  {
    name: I18n.t('generic.id'),
    field: 'id',
    required: true,
  },
  {
    name: I18n.t('generic.name'),
    field: 'name',
    required: true,
  },
  {
    name: I18n.t('generic.member_posts'),
    renderElement: record => record.member_posts.map(post => post.name).join(),
    field: 'member_posts',
    required: false,
  },
]

const AgentRelatedPostsIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle(I18n.t('generic.member_posts'))
  const { data: user } = agentService.getDataFromJson(props.user)
  const { data, pagination } = agentService.getDataFromJson(props.posts.posts)
  const posts = sortBy(data, 'member_posts')

  return (
    <SidebarLayout user={user} showSidebar={true}>
      <Panel>
        <EditTable
          editable={true}
          columns={COLUMNS}
          records={posts}
          pagination={pagination}
          getEditLink={({ id }) => `/agent/posts/${id}/member_posts/edit`}
        />
      </Panel>
    </SidebarLayout>
  )
}

export default AgentRelatedPostsIndex
